import React, { useState, useEffect } from 'react';
import styles from './confirmWithFinancialCriteriaModal.module.scss';
import { Button, WithSpinner } from '../../components';
import { actions } from '../../state/actions';
import { connect } from 'react-redux';
import { criteriaValuep } from '../../utils/translation/criteria';

const ConfirmWithFinancialCriteriaModal = ({
  open,
  dispatch,
  text,
  loading,
  financialCriteriaResults,
  id,
  finYear,
}) => {
  const [agree, setAgree] = useState(false);
  const [showError, setShowError] = useState(false);

  const onAgree = () => {
    agree === false ? setShowError(false) : setShowError(true);
    setAgree(!agree);
  };
  const cancel = () => {
    setAgree(false);
    setShowError(false);
    const open = {
      modalName: 'confirmWithFinancialCriteriaModal',
      visible: false,
    };
    dispatch(actions.modals.setModalVisibleFlagAction(open));
  };

  const cancel2 = () => {
    setAgree(false);
    setShowError(false);
    cancel();
    dispatch(
      actions.dashboard.createNewRequestAction(
        id.RequestSystemInfo.RequestId,
        'view'
      )
    );
  };
  const yes = () => {
    dispatch(
      actions.dashboard.sendForApproveAction(id.RequestSystemInfo.RequestId)
    );

    cancel();
  };

  const [data, setData] = useState(financialCriteriaResults);
  useEffect(() => {
    if (financialCriteriaResults && financialCriteriaResults.Rules) {
      setData(financialCriteriaResults);
    }
    // if denied - reload
  }, [financialCriteriaResults]);

  const [dataFiltered, setDataFiltered] = useState(null);
  useEffect(() => {
    if (data && data.Rules) {
      setDataFiltered(data.Rules);
    }
  }, [data]);

  return (
    open && (
      <WithSpinner loading={loading}>
        <div className={styles.container}>
          <div
            className={styles.modal}
            id="modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal__title"
            aria-describedby="modal__desc"
            style={{ minHeight: '300px' }}
          >
            <div className={styles.contentBlock}>
              <h2>Atitikimo finansavimui kriterijai</h2>
              <div className={styles.criteriaContainer}>
                {data != null &&
                  data.Decision != null &&
                  dataFiltered?.length !== 0 &&
                  dataFiltered?.map((val, i) => (
                    <div
                      style={{
                        color: val.Decision === 'Denied' ? 'red' : 'green',
                      }}
                      className={styles.criteriaContainer}
                      key={i}
                    >
                      {val.RuleName === 'FinancialIndicators' ? (
                        finYear === 2020 ? (
                          criteriaValuep('FinancialIndicators2020')
                        ) : (
                          criteriaValuep(val.RuleName)
                        )
                      ) : val.RuleName === 'CompanyLongTermDebtor' ? (
                        <span>
                          Pareiškėjas atitinka minimalius Lietuvos Respublikos
                          mokesčių administravimo įstatymo 40<sup>1</sup>{' '}
                          straipsnyje nustatytus patikimų mokesčių mokėtojų
                          kriterijus
                        </span>
                      ) : (
                        criteriaValuep(val.RuleName)
                      )}
                    </div>
                  ))}
                {/*} {
                  text.Decision === 'Accepted'  (
                    <p
                      style={{
                        fontSize: '1.3rem',
                        marginBottom: '2rem',
                        color: 'green',
                      }}
                    >
                      Paraiška atitinka keliamus kriterijus. Pateikite paraišką vertinimui.
                    </p>
                    )}*/}
              </div>

              {data && data.Decision === 'Accepted' ? (
                <>
                  <div className={styles.btnContainer}>
                    <Button type="standart" onClick={() => yes()}>
                      Pateikti
                    </Button>
                    <Button type="cancel" onClick={() => cancel()}>
                      Atšaukti
                    </Button>
                  </div>
                </>
              ) : (
                <>
                  <p
                    style={{
                      fontSize: '1.3rem',
                      marginBottom: '2rem',
                      color: 'red',
                    }}
                  >
                    Jūsų paraiška negali būti pateikta tolimesniam vertinimui,
                    nes neatitinka minimalių reikalavimų paskolai gauti. Su
                    sprendimu dėl kriterijų neatitikimo galite susipažinti
                    skiltyje "Sutartis ir pasirašymas".
                  </p>
                  <div>
                    <button
                      type="standart"
                      onClick={() => cancel2()}
                      className="vaiisisloginbtn"
                      style={{ marginTop: '0rem' }}
                    >
                      Gerai
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </WithSpinner>
    )
  );
};

const mapStateToProps = (state) => ({
  text: state.modalsState.msgText,
  // loading: state.modalsState.isOnSync,
  financialCriteriaResults: state.dashboardState.financialCriteriaResults,
  id: state.dashboardState.requestData,
  sectorType: state.dashboardState.requestData.LoanInfo,
});

export default connect(mapStateToProps)(ConfirmWithFinancialCriteriaModal);
